import { timeline, animate } from "motion";

// entire graphic
animate(".secret-animation", {
	opacity: 1,
}, {
	duration: 1,
	delay: 1,
});

timeline([
	[".secret-animation #pyramid", {
		opacity: [0, .15, 0],
	}, {
			easing: "ease-in"
		}
	],
	[".secret-animation #circles", {
		opacity: [0, .15, 0],
	}, {
			easing: "ease-in"
		}
	],
	[".secret-animation #keyhole", {
		opacity: [0, .15, 0],
	}, {
			easing: "ease-in"
		}
	],
], {
	duration: 4,
	repeat: Infinity,
	delay: 2
});



timeline([
	[".secret-animation .question", {
		opacity: [0, 1]
	}],
	[".secret-animation .response", {
		opacity: [0, 1]
	}],
	[".secret-animation .buttons", {
		opacity: [0, 1]
	}],
], {
	duration: 4,
	delay: 2,
});

animate(".secret-animation .scroll-carat", {
	opacity: [0, 1],
}, {
	duration: 1,
	delay: 5,
});
